import type { RichText as RichTextContent } from '@silvertours/common-landingpages-view';

import { ContentfulRichText } from './ContentfulRichText';
import type { HasTextStyleRules } from './rules';
import { MarkupRichText } from './MarkupRichText';
import type { RenderCtaLink } from './extractEmbeddedCtaLink';

export type RichTextRules = HasTextStyleRules;

export type RichTextProps = {
  content?: RichTextContent;
  rules?: RichTextRules & {
    disableSnippetStyles?: boolean;
    isMultiColumn?: boolean;
  };
  renderCtaLink?: RenderCtaLink;
};

export const RichText = ({ content, rules, renderCtaLink }: RichTextProps) => {
  if (!content) {
    return null;
  }

  if (content.type === 'html-string') {
    return <MarkupRichText content={content} />;
  }

  const { disableSnippetStyles = false, isMultiColumn = false } = rules ?? {};
  const shouldExtractSnippets = !disableSnippetStyles && !isMultiColumn;

  return (
    <ContentfulRichText
      content={content}
      rules={rules}
      enableSnippetExtraction={shouldExtractSnippets}
      renderCtaLink={renderCtaLink}
    />
  );
};
